import { render } from "./TopNav.vue?vue&type=template&id=54430f85&scoped=true"
const script = {}

import "./TopNav.vue?vue&type=style&index=0&id=54430f85&scoped=true&lang=css"

import exportComponent from "/Users/ken/Documents/Workspace/junipop/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47_webpack@5.79.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54430f85"]])

export default __exports__